<template>
  <div>
    <div class="container">
      <section class="section" style="text-align: left; padding-left:0px">
        <div class="container">
          <h1 class="title">{{ $t('project.title') }}</h1>
        </div>
      </section>
    </div>
    <!--carousel perPage="1">
      <slide>
        Slide 1 Content
        <div class="container" align="left">
          <figure class="image is-16x9">
            <img src="../assets/home.png">
          </figure>
        </div>
      </slide>
      <slide>
        Slide 2 Content
        <div class="container" align="left">
          <figure class="image is-16x9">
            <img src="../assets/home.png">
          </figure>
        </div>
      </slide>
      <slide>
        Slide 2 Content
      </slide>
      <slide>
        Slide 2 Content
        <div class="container" align="left">
          <figure class="image is-16x9">
            <img src="../assets/home.png">
          </figure>
        </div>
      </slide>
      <slide>
        Slide 2 Content
        <div class="container" align="left">
        <figure class="image is-16x9">
          <img src="../assets/home.png">
        </figure>
      </div>
      </slide>
    </carousel-->
    <div class="container">
      <figure class="image">
        <img src="../assets/project1.png">
      </figure>
    </div>
    <br /><br />
    <div class="container">
      <figure class="image">
        <img src="../assets/project2.png">
      </figure>
    </div>
    <div class="container">
      <section class="section" style="text-align: left; padding-left:0px">
        <div class="container">
          <h1 class="title" style="font-size:0.85em"><strong>55 SOUTH URUMQI ROAD, 6,500 M², SHANGHAI CHINA</strong></h1>
          <h2 class="subtitle" style="font-size:0.85em; line-height:150%; margin-bottom: 40px">
            TOPFLOOR: PENTHOUSE WITH GALLERY; F5: 55 BY THE GROUP MEMBERSHIP CLUB (ART SPACE); F3: JIPIN (FINE HONG KONG CANTONESS CUISINE WITH 8-ARTIST VIP ROOMS; F2: WHITE BANQUET HALL; F1: AMEK CREATIVE FRENCH DINING WITH THE CENTURION® ROOM, PASSAGE BY AKEM WITH FRENCH DREAM GARDEN; B1: WINE RESIDENCE (CELLARS); B2: FROZEN CHAMBER, ADMIN OFFICE
          </h2>
          <h1 class="title" style="font-size:0.85em"><strong>DIGITAL PROJECTS ROLE</strong></h1>
          <h2 class="subtitle" style="font-size:0.85em; line-height:150%;">
            CLIENT REPRESENTATIVE IN CHARGE OF WHOLE PROJECT PROGRAMME AND PROJECT MANAGEMENT THROUGHOUT SITE SELECTION & INVESTIGATION (TDD), BUSINESS STRATEGY AND BUSINESS PLAN, DESIGNER SELECTION, DESIGN MANAGEMENT, CONTRACTOR SELECTION, CONSTRUCTION MANAGEMENT, PROCUREMENT MANAGEMENT, VALUE ENGINEERING ANALYSIS, TESTING & COMMISSIONING MANAGEMENT, MOVE-IN & OCCUPANCY, AND SOFT OPENING COORDINATION.
          </h2>
        </div>
      </section>
    </div>
    <br/>
    <div class="container">
      <figure class="image">
        <img src="../assets/project3.png">
      </figure>
    </div>
    <div class="container">
      <section class="section" style="text-align: left; padding-left:0px">
        <div class="container">
          <h1 class="title" style="font-size:0.85em"><strong>NOVARTIS SHANGHAI CAMPUS, SHANGHAI CHINA</strong></h1>
        </div>
      </section>
    </div>
    <br/>
    <div class="container">
      <figure class="image">
        <img src="../assets/project4.png">
      </figure>
    </div>
    <div class="container">
      <section class="section" style="text-align: left; padding-left:0px">
        <div class="container">
          <h1 class="title" style="font-size:0.85em"><strong>AstraZeneca TAIZHOU PROJECT, JIANGSU CHINA</strong></h1>
        </div>
      </section>
    </div>
    <br/>
    <div class="container" style="width:900px;">
      <figure class="image" style="margin-left:0; width:30%">
        <img src="../assets/project5.jpg">
      </figure>
    </div>
    <div class="container">
      <section class="section" style="text-align: left; padding-left:0px">
        <div class="container">
          <h1 class="title" style="font-size:0.85em"><strong>YUJIAPU FINANCE DEVELOPMENT ZONE, TIANJIN CHINA</strong></h1>
          <h2 class="subtitle" style="font-size:0.85em; line-height:150%;">
            YUJIAPU 03-16 (54-StOREY, 246.50M), 03-21 (34-STOREY, 155.60M) & B3 METRO SPACE, TOTAL GFA 400,000 M², - 25.95M PIT - THE SCALE OF THIS DEEP FOUNDATION PIT IS 400 x 280 M, WHICH IS THE LARGEST SINGLE ONE AT THAT TIME IN CHINA.
          </h2>
        </div>
      </section>
    </div>
    <br/>
    <div class="container">
      <figure class="image">
        <img src="../assets/project6.png">
      </figure>
    </div>
    <div class="container">
      <section class="section" style="text-align: left; padding-left:0px">
        <div class="container">
          <h1 class="title" style="font-size:0.85em"><strong>SIEMENS CENTRE SHANGHAI (SCS), 55,000 M², SHANGHAI CHINA</strong></h1>
        </div>
      </section>
    </div>
    <br/>
    <div class="container">
      <figure class="image">
        <img src="../assets/project7.png">
      </figure>
    </div>
    <div class="container">
      <section class="section" style="text-align: left; padding-left:0px">
        <div class="container">
          <h1 class="title" style="font-size:0.85em"><strong>UME INTERNATIONAL CINEPLEX, XINTIANDI, SHANGHAI CHINA</strong></h1>
        </div>
      </section>
    </div>
    <br/>
    <div class="container">
      <figure class="image">
        <img src="../assets/project8.png">
      </figure>
    </div>
    <div class="container">
      <section class="section" style="text-align: left; padding-left:0px">
        <div class="container">
          <h1 class="title" style="font-size:0.85em"><strong>RADISSON BLU PLAZA XINGGUO HOTEL, SHANGHAI CHINA</strong></h1>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Project'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Project.vue